'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _print = require('../print');

var _print2 = _interopRequireDefault(_print);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var fPDFReportsService = function () {
  function fPDFReportsService($window, fPrint, msgService, $q, $filter) {
    _classCallCheck(this, fPDFReportsService);

    this._ = { fPrint: fPrint, msgService: msgService, $q: $q, $filter: $filter };
  }

  _createClass(fPDFReportsService, [{
    key: 'addPage',
    value: function addPage(sublist, cols, pageNum) {
      var _this = this;

      var _$fPrint$metrics = this._.fPrint.metrics(),
          margin = _$fPrint$metrics.margin,
          pageWidth = _$fPrint$metrics.pageWidth,
          useablePageWidth = _$fPrint$metrics.useablePageWidth,
          positionY = void 0;

      var headlineSize = 16,
          subheadSize = 11,
          normalFont = 'Helvetica',
          bold = 'Helvetica-Bold',
          width = useablePageWidth,
          height = 31,
          numRows = sublist.length + 1;

      positionY = margin;

      if (pageNum > 1) {
        this.doc.addPage();
      }

      this.doc.font(normalFont);
      this.doc.fontSize(headlineSize);
      this.doc.text(this.title, margin, positionY, {
        align: 'center',
        lineBreak: true,
        width: useablePageWidth,
        height: headlineSize,
        ellipsis: true
      });

      positionY += headlineSize;

      this.doc.moveDown(0.5);
      this.doc.fontSize(11);
      this.doc.text('Page ' + pageNum, {
        align: 'right',
        width: useablePageWidth,
        lineBreak: true
      });

      positionY += 31;

      var tableStartY = positionY,
          tableEndY = tableStartY + ((numRows - 1) * height + 32);

      var positionX = margin;

      // Calculate column starting positions
      cols.forEach(function (col) {
        col.x = positionX;
        positionX += col.width * width;
      });

      // Add end column line
      cols.push({ x: pageWidth - margin });

      // Draw row lines
      for (var _r = 0; _r <= numRows; _r++) {
        this.doc.moveTo(margin, positionY).lineTo(margin + width, positionY).stroke();

        positionY += _r == 0 ? 32 : height;
      }

      // Draw column lines
      cols.forEach(function (col) {
        _this.doc.moveTo(col.x, tableStartY).lineTo(col.x, tableEndY).stroke();

        if (!col.name) return;
        _this.doc.font(bold);
        _this.doc.fontSize(col.fontSize ? col.fontSize : subheadSize);
        var x = col.align === 'left' ? col.x + 5 : col.x;
        _this.doc.text(col.name, x, tableStartY + (32 - subheadSize) / 2, {
          width: col.width * width,
          align: col.align ? col.align : 'center',
          lineBreak: false,
          ellipsis: true
        });
      });

      var r = 0;

      positionY = tableStartY + 32;

      this.doc.font(normalFont);

      sublist.forEach(function (record) {

        if (record.name === 'Grand Total') {
          _this.doc.font(bold);
        }

        var textY = positionY + (32 - subheadSize) / 2;

        cols.forEach(function (cl) {
          var text = typeof record[cl.propertyName] === 'undefined' ? '' : record[cl.propertyName].toString(),
              x = cl.align === 'left' ? cl.x + 5 : cl.x;

          _this.doc.fontSize(cl.fontSize ? cl.fontSize : subheadSize);

          _this.doc.text(text, x, textY, {
            width: cl.width * width,
            align: cl.align ? cl.align : 'center',
            lineBreak: false,
            ellipsis: true
          });
        });

        positionY += r == 0 ? 32 : height;

        r++;
      });
    }
  }, {
    key: 'convertToPDF',
    value: function convertToPDF(objArray, rowArray) {
      var _this2 = this;

      var title = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Feis Report';
      var name = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'feis-report';

      objArray = this._.$filter('orderBy')(objArray, 'name');
      this.doc = this._.fPrint.create(name + '.pdf');
      this.title = title;
      // FIXME(joshdmiller): wtf was this fetching the logo?
      return this._.fPrint.getLogo().then(function (logo) {
        return _this2.logo = logo;
      }).then(function () {
        return _this2.preparePDF(objArray, rowArray);
      });
    }
  }, {
    key: 'preparePDF',
    value: function preparePDF(objArray, colArray) {

      var rowPerPage = 20;

      var pageNumber = void 0,
          objTotals = colArray.reduce(function (o, x) {
        var prop = x.propertyName;

        if (typeof objArray[0][prop] === 'number') {
          o[prop] = objArray.reduce(function (p, y) {
            return p + y[prop];
          }, 0);
        }

        return o;
      }, {
        name: 'Grand Total'
      });

      for (var i = 0; i < objArray.length; i += rowPerPage) {
        var sublist = void 0;
        if (i + rowPerPage > objArray.length) {
          sublist = objArray.slice(i, objArray.length);
          sublist.push(objTotals);
        } else {
          sublist = objArray.slice(i, i + rowPerPage);
        }
        pageNumber = i / rowPerPage + 1;
        this.addPage(sublist, colArray, pageNumber);
      }

      if (objArray.length % rowPerPage === 0) {
        this.addPage([objTotals], colArray, pageNumber + 1);
      }

      this._.fPrint.download(this.doc);
    }
  }]);

  return fPDFReportsService;
}();

exports.default = angular.module('ifeis.pdf', []).service('fPDFReportsService', fPDFReportsService);


//////////////////
// WEBPACK FOOTER
// ./reports-pdf/index.js
// module id = 505
// module chunks = 0